import React from 'react';
import Image from '../../../components/AppImage';
import Button from '../../../components/ui/Button';

const CultureHero = () => {
  const cultureStats = [
    { number: "95%", label: "Employee Satisfaction" },
    { number: "4.8/5", label: "Glassdoor Rating" },
    { number: "2.3x", label: "Faster Career Growth" },
    { number: "100%", label: "Learning Budget Coverage" }
  ];

  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-accent py-20 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 geometric-flow opacity-90"></div>
      <div className="absolute inset-0 bg-black/20"></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <div className="text-white space-y-8">
            <div className="space-y-6">
              <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold font-heading leading-tight">
                Life at 
                <span className="block text-accent">Ons Mettle</span>
              </h1>
              <p className="text-xl lg:text-2xl text-white/90 font-body leading-relaxed">
                Where exceptional talent meets transformational opportunities. Join a team that doesn't just deliver projects—we shape the future of business.
              </p>
            </div>

            {/* Stats Grid */}
            <div className="grid grid-cols-2 gap-6">
              {cultureStats.map((stat, index) => (
                <div key={index} className="text-center lg:text-left">
                  <div className="text-3xl lg:text-4xl font-bold text-accent font-heading">
                    {stat.number}
                  </div>
                  <div className="text-sm lg:text-base text-white/80 font-body">
                    {stat.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button 
                variant="default" 
                size="lg"
                className="bg-accent hover:bg-accent/90 text-white font-cta"
              >
                View Open Positions
              </Button>
              <Button 
                variant="outline" 
                size="lg"
                className="border-white text-primary hover:bg-white hover:text-primary font-cta"
              >
                Meet Our Team
              </Button>
            </div>
          </div>

          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
                alt="Ons Mettle team collaboration in modern office"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
            </div>
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 -left-6 bg-white rounded-xl p-6 shadow-xl max-w-xs">
              <div className="flex items-center space-x-4">
                <div className="w-12 h-12 bg-accent rounded-full flex items-center justify-center">
                  <span className="text-white font-bold text-lg">4.8</span>
                </div>
                <div>
                  <div className="font-semibold text-primary font-heading">Great Place to Work</div>
                  <div className="text-sm text-text-secondary font-body">Certified 2024</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CultureHero;